var reflectionSheenPS = `

void addReflectionSheen() {
		float NoV = dot(dNormalW, dViewDirW);
		float alphaG = sGlossiness * sGlossiness;

		// Avoid using a LUT and approximate the values analytically
		float a = sGlossiness < 0.25 ? -339.2 * alphaG + 161.4 * sGlossiness - 25.9 : -8.48 * alphaG + 14.3 * sGlossiness - 9.95;
		float b = sGlossiness < 0.25 ? 44.0 * alphaG - 23.7 * sGlossiness + 3.26 : 1.97 * alphaG - 3.27 * sGlossiness + 0.72;
		float DG = exp( a * NoV + b ) + ( sGlossiness < 0.25 ? 0.0 : 0.1 * ( sGlossiness - 0.25 ) );
		sReflection += calcReflection(dNormalW, 0.0) * saturate(DG);
}
`;

export { reflectionSheenPS as default };
